var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"modal-text","size":"sm","hide-footer":"","hide-header":""}},[_c('div',{staticClass:"text-center my-2"},[_c('img',{staticClass:"mb-4",attrs:{"src":_vm.renderImage(),"width":"100"}}),_c('p',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.textModal))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }